module.exports = __webpack_public_path__ + "static/media/MHRM84N0001.86f0d3e9.svg";